import { useMemo } from 'react'
import { formatCurrency } from '@lib/utils/formatCurrency'
import { translateRatingToDecimal } from '@lib/utils/translateRatingToDecimal'
import { ExtendedProductType } from '@pylot/types/product-extensions'

const NEW_FLAG_STRING = 'NUEVO'

export const usePDPData = (
    product: ExtendedProductType | null,
    variant: any
) => {
    return useMemo(() => {
        if (!product) return null

        const {
            name,
            short_description = { html: '' },
            price_range: productPriceRange,
            badge_image_text: badgeImageText,
            badge_caption_icon: badgeCaptionIcon,
            flag,
            reviews,
            rating_summary,
            review_count
        } = product

        const { sku, price_range: variantPriceRange } = variant || {}

        const effectiveIsSet =
            variant?.sku && variant.sku !== product.sku
                ? variant.is_set
                : product.is_set

        const effectivePpum =
            variant?.sku && variant.sku !== product.sku
                ? variant.ppum
                : product.ppum

        const unitPrice = formatCurrency(effectivePpum ? effectivePpum : '')

        let flagNuevo = false
        product.categories?.forEach((categoria: any) => {
            if (categoria.name === 'Nuevos') {
                flagNuevo = true
            }
        })

        const badgeLabel = flagNuevo ? NEW_FLAG_STRING : badgeImageText
        const badgeText = flag ? flag.label : badgeLabel

        const commentWording =
            review_count > 1 || review_count == 0
                ? ' comentarios'
                : ' comentario'

        const ratingDisplay = `${translateRatingToDecimal(
            rating_summary
        )} | (${review_count}${commentWording})`

        return {
            name,
            sku,
            effectiveIsSet,
            effectivePpum,
            unitPrice,
            badgeText,
            badgeCaptionIcon,
            productPriceRange,
            variantPriceRange,
            reviews,
            rating_summary,
            review_count,
            short_description,
            commentWording,
            ratingDisplay
        }
    }, [product, variant])
}
